import React, {useState,  useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {useInterval, updateUTCDate} from '../../common/app_common.js';
import {PageNation, GotoMonitoring} from '../../common/component_common.js';
import {getApiEdgeId} from '../../common/fetch_api/edge'
import {getApiDataEndpointCount, getApiDataEndpoint} from '../../common/fetch_api/data_end_point';
import {BsExclamationCircle, BsPencilSquare, BsChevronExpand} from 'react-icons/bs'
import {DataEndPointCreate, DataEndPointEdit, EdgeInfoModal} from './modals';

const PAGE_PER = 16;

export const View = ({runUpdateTab}) => {
    
    const [update, setUpdate] = useState(false);

    const [tableSpinner, setTableSpinner] = useState(false);
    const [dataEdgeList, setDataEdgeList] = useState(null);
    
    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const [endPointData, setEndPointData] = useState(null);
    
    const sortInfo = useRef({title:'', order:''});
    
    const [modalEndPointCreate, setModalEndPointCreate] = useState(false);
    const closeModalEndPointCreate = () => setModalEndPointCreate(false);
    const showModalEndPointCreate = () => setModalEndPointCreate(true);

    const [modalEndPointEdit, setModalEndPointEdit] = useState(false);
    const closeModalEndPointEdit = () => setModalEndPointEdit(false);
    const showModalEndPointEdit = (dataEndPoint) => {
        setEndPointData(dataEndPoint);
        setModalEndPointEdit(true);
    }

    const [edgeInfoId, setEdgeInfoId] = useState(null);
    
    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeModalEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }

    const getEdges = () => {
        curPageRef.current.value = curPageState;

        Promise.resolve( getApiDataEndpointCount() )
        .then( data => {
            if(data && data.count > 0)
            {
                setEdgeSelCount(data.count);

                Promise.resolve( getApiDataEndpoint(PAGE_PER, curPageState, sortInfo.current.title, sortInfo.current.order) )
                .then( data => {
                    let html = [];
                    data.forEach( (dataEndPoint, idx) => {
                        if(dataEndPoint.id.length > 1)
                        {
                            Promise.resolve(getApiEdgeId(dataEndPoint.id))
                            .then( edge => {

                                let type = 'T';
                                if( edge.type === 'm-agent' ) type = 'M';
                                else if( edge.type === 's-agent' ) type = 'S';
                                else if( edge.type === 'r-agent' ) type = 'R';
                                
                                let curTime = new Date();
                                let checkIn = new Date(0);
                                checkIn.setUTCSeconds(edge.sec);

                                html.push(
                                    <tr key={dataEndPoint.id} id={dataEndPoint.id}>
                                        <td><div className="edge-box edge-default"><span className="edge-item">{type}</span></div></td>
                                        <td title={dataEndPoint.id}>{dataEndPoint.id}</td>
                                        <td title={dataEndPoint.name}>{dataEndPoint.name}</td>
                                        <td title={dataEndPoint.uri}>{dataEndPoint.uri}</td>
                                        <td title={dataEndPoint.scrapeInterval}>{`${dataEndPoint.scrapeInterval} sec`}</td>
                                        <td className={`${(curTime.getTime() - checkIn.getTime()) >= 60000? "text-warning":""}`}title={updateUTCDate(checkIn)}>{updateUTCDate(checkIn)}</td>
                                        <td>
                                            <GotoMonitoring siteName={edge.site} edgeId={edge.id} type={edge.type}/>
                                        </td>
                                        <td>
                                            <Button variant='primary' className="btn btn-icon" onClick={() => {showModalEdgeInfo(edge.id);}}><BsExclamationCircle/></Button>
                                        </td>
                                        <td>
                                            <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEndPointEdit(dataEndPoint)}}><BsPencilSquare/></Button>
                                        </td>
                                    </tr>
                                );

                                if(idx+1 >= data.length)
                                {
                                    setTimeout(() => {
                                        setTimeout(() => {setTableSpinner(false);}, 700);
                                        setDataEdgeList(html);
                                    }, 100);
                                }
                            })
                            .catch( e => {
                                setTimeout(() => {setTableSpinner(false);}, 700);
                            });
                        }
                        else
                        {
                            setTimeout(() => {setTableSpinner(false);}, 700);
                        }
                    });
                })
                .catch( e => {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                });
            }
            else
            {
                setDataEdgeList([]);
                setTimeout(() => {setTableSpinner(false);}, 700);
            }
        })
        .catch( e => {
            setTimeout(() => {setTableSpinner(false);}, 700);
        });
    };
    
    function toggleSort(title)
    {
        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        getEdges();
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        setTableSpinner(true);
        getEdges();
    }, [update, curPageState, runUpdateTab]);

    // useInterval(() =>
    // {
    //     runUpdate();
    // }, 30000 );

    return (
        <>
            <div className="d-flex justify-content-end mt-2 me-2">
                <Button variant="primary" className="btn btn-sm" onClick={showModalEndPointCreate}>Create DataEndpoint</Button>
            </div>
            <div className="section dataendpoint-area position-relative mt-2">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table">
                    <thead>
                        <tr>
                            <th className="sorting" onClick={() => {toggleSort('type');}}>Type<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('id');}}>ID<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('name');}}>Name<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('uri');}}>URI<BsChevronExpand /></th>
                            <th>ScrapeInterval</th>
                            <th>Latest Check in</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataEdgeList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={edgeSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalEndPointCreate&&<DataEndPointCreate show={modalEndPointCreate} handleClose={closeModalEndPointCreate} updateContents={runUpdate} ></DataEndPointCreate>}
            {modalEdgeInfo&&<EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeModalEdgeInfo}></EdgeInfoModal>}
            {modalEndPointEdit&&<DataEndPointEdit dataEndPointData={endPointData} show={modalEndPointEdit} handleClose={closeModalEndPointEdit} updateContents={runUpdate} ></DataEndPointEdit>}
        </>
    )
}
